module.exports = __webpack_public_path__ + "static/images/9-icon.d27d34696.png";